{% block sw_first_run_wizard_paypal_credentials %}
<div class="sw-first-run-wizard-paypal-credentials">
    <p class="sw-first-run-wizard-paypal-credentials__headerText">
        {{ $t('swag-paypal-frw-credentials.textIntroPayPal') }}
    </p>

    <template v-if="settingsStore.isLoading">
        <sw-skeleton-bar />
        <sw-skeleton-bar />
        <sw-skeleton-bar />
    </template>

    <template v-else>
        <swag-paypal-setting
            path="SwagPayPal.settings.sandbox"
            :bordered="false"
            :disabled="inputsDisabled"
            @update:value="resetError()"
        />

        <swag-paypal-onboarding-button
            v-show="!settingsStore.isSandbox"
            mode="live"
            :disabled="inputsDisabled"
        >
            {{ $t('swag-paypal-frw-credentials.buttonGetCredentials') }}
        </swag-paypal-onboarding-button>

        <swag-paypal-onboarding-button
            v-show="settingsStore.isSandbox"
            mode="sandbox"
            :disabled="inputsDisabled"
        >
            {{ $t('swag-paypal-frw-credentials.buttonGetSandboxCredentials') }}
        </swag-paypal-onboarding-button>

        <swag-paypal-setting
            v-show="!settingsStore.isSandbox"
            path="SwagPayPal.settings.clientId"
            :disabled="inputsDisabled"
            :error="error"
        />
        <swag-paypal-setting
            v-show="!settingsStore.isSandbox"
            path="SwagPayPal.settings.clientSecret"
            :disabled="inputsDisabled"
            :error="error"
        />
        <swag-paypal-setting
            v-show="!settingsStore.isSandbox"
            path="SwagPayPal.settings.merchantPayerId"
            :disabled="inputsDisabled"
            :error="error"
        />

        <swag-paypal-setting
            v-show="settingsStore.isSandbox"
            path="SwagPayPal.settings.clientIdSandbox"
            :disabled="inputsDisabled"
            :error="error"
        />
        <swag-paypal-setting
            v-show="settingsStore.isSandbox"
            path="SwagPayPal.settings.clientSecretSandbox"
            :disabled="inputsDisabled"
            :error="error"
        />
        <swag-paypal-setting
            v-show="settingsStore.isSandbox"
            path="SwagPayPal.settings.merchantPayerIdSandbox"
            :disabled="inputsDisabled"
            :error="error"
        />

        <mt-switch
            v-model:modelValue="asDefault"
            :disabled="!hasCredentials || inputsDisabled"
            :label="$t('swag-paypal-frw-credentials.labelSetDefault')"
            :helpText="$t('swag-paypal-frw-credentials.tooltipSetDefault')"
        />

        <sw-loader v-if="isLoading" />
    </template>
</div>
{% endblock %}
